<template>
    <div>
        <vx-card class="mb-0 report-card-shell">
            <div class="container mx-auto px-4">
                <div class="mb-6 mt-5">
                    <div class="report-hero mb-4">
                        <div class="report-hero__copy">
                            <span class="report-hero__eyebrow">Gerencia / Reportes</span>
                            <h2 class="report-hero__title text-lg font-bold">Reporte de Ventas por Periodo</h2>
                            <p class="report-hero__subtitle text-[10px]">Vista ejecutiva compacta para revisión rápida de resultados y pagos.</p>
                        </div>
                        <div class="flex gap-3 flex-wrap justify-end">
                            <vs-button color="success" type="filled" @click="exportar" class="shadow-sm report-action-btn report-btn-primary">
                                Exportar
                            </vs-button>
                            <vs-button color="success" type="filled" icon="refresh" @click="recargarPedidos" class="shadow-sm report-action-btn report-btn-secondary">
                                Recargar
                            </vs-button>
                            <vs-button color="danger" type="filled" icon="clear" @click="limpiarSeleccion" class="shadow-sm report-action-btn report-btn-danger">
                                Limpiar
                            </vs-button>
                        </div>
                    </div>

                    <div class="report-stats-grid">
                        <div v-for="stat in resumenReporte" :key="stat.label" class="report-stat-card" :class="stat.className">
                            <span class="report-stat-label">{{ stat.label }}</span>
                            <span class="report-stat-value">{{ stat.value }}</span>
                            <span class="report-stat-helper">{{ stat.helper }}</span>
                        </div>
                    </div>

                    <div class="report-toolbar">
                        <div class="report-filter-card">
                            <div class="report-filter-card__label">
                                <span class="report-filter-card__title">Filtros</span>
                                <span class="report-filter-card__subtitle">Selecciona periodos para actualizar el reporte</span>
                            </div>
                            <v-select multiple :options="arrayPeriodos" label="periodoescolar" :reduce="p => p.idperiodoescolar"
                                v-model="periodoSelect" class="w-full multi-select-height report-select" @input="f_get_pedidos_periodos"
                                placeholder="Seleccione periodos..." />
                        </div>

                        <div v-if="pedidos.length > 0" class="report-search-card">
                            <div class="flex items-center gap-3">
                                <span class="report-search-icon">Buscar</span>
                                <input
                                    v-model="searchQuery"
                                    type="text"
                                    placeholder="Buscar por institución, pedido, asesor..."
                                    class="flex-1 px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent report-search-input"
                                />
                                <span class="report-search-count text-xs">{{ pedidosFiltrados.length }} de {{ pedidos.length }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Tabla de Reportes CORREGIDA -->
                <div class="mt-8 overflow-x-auto report-table-shell">
                    <table class="min-w-full bg-white rounded-2xl overflow-hidden report-table report-table-fixed">
                        <colgroup>
                            <col class="report-col-institution" />
                            <col class="report-col-summary" />
                            <col class="report-col-payments" />
                        </colgroup>
                        <thead>
                            <tr class="report-table-head">
                                <th class="py-2 px-3 text-left font-bold text-[9px] uppercase tracking-[0.12em] text-slate-700 sticky top-0 z-10">
                                    <div class="flex items-center gap-2">
                                        <span class="report-th-index">1</span>
                                        <span>Institución</span>
                                    </div>
                                </th>
                                <th class="py-2 px-3 text-left font-bold text-[9px] uppercase tracking-[0.12em] text-slate-700 sticky top-0 z-10">
                                    <div class="flex items-center gap-2">
                                        <span class="report-th-index">2</span>
                                        <span>Convenio & Resumen</span>
                                    </div>
                                </th>
                                <th class="py-2 px-3 text-left font-bold text-[9px] uppercase tracking-[0.12em] text-slate-700 sticky top-0 z-10">
                                    <div class="flex items-center gap-2">
                                        <span class="report-th-index">3</span>
                                        <span>Detalle de Pagos</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="pedidos.length === 0">
                                <td colspan="3" class="text-center py-10 text-gray-500">
                                    <div class="report-empty-state">
                                        <p class="text-sm font-semibold text-gray-700">No hay pedidos para mostrar</p>
                                        <p class="text-[10px] text-gray-500 mt-1">Selecciona uno o varios periodos para cargar el reporte</p>
                                    </div>
                                </td>
                            </tr>
                            <tr v-else-if="pedidos.length > 0 && pedidosFiltrados.length === 0">
                                <td colspan="3" class="text-center py-10 text-gray-500">
                                    <div class="report-empty-state">
                                        <p class="text-sm font-semibold text-gray-700">Sin resultados para tu búsqueda</p>
                                        <p class="text-[10px] text-gray-500 mt-1">Prueba con otro término o limpia el filtro</p>
                                    </div>
                                </td>
                            </tr>
                            <tr v-else v-for="pedido in pedidosFiltrados" :key="pedido.id_pedido" class="report-row-hover transition-all duration-200">
                                <td class="py-2 px-3 report-cell-soft align-top">
                                    <div class="report-panel report-panel--institution">
                                        <span class="report-section-eyebrow">Institución</span>
                                        <h3 class="report-section-title report-title-tight">{{ pedido.nombreInstitucion }}</h3>
                                        <p class="report-section-subtitle">
                                            Pedido {{ pedido.pedido_institucion_id }} · Conv. {{ pedido.pedidos_convenios_id }}
                                        </p>
                                        <div class="report-summary-list report-summary-list--institution">
                                            <div class="report-summary-row">
                                                <span class="report-mini-card__label">Asesor</span>
                                                <span class="report-mini-card__value">{{ pedido.asesor_nombres }} {{ pedido.asesor_apellidos }}</span>
                                            </div>
                                            <div class="report-summary-row">
                                                <span class="report-mini-card__label">Contrato</span>
                                                <span class="report-mini-card__value">{{ pedido.contrato_generado }}</span>
                                            </div>
                                        </div>
                                        <div class="report-mini-badges">
                                            <span class="report-badge report-badge--blue">{{ pedido.tipo_venta_descr }}</span>
                                            <span class="report-badge report-badge--slate">{{ pedido.nombre_periodo }}</span>
                                        </div>
                                    </div>
                                </td>
                                <td class="py-2 px-3 report-cell-accent align-top">
                                    <div class="report-panel report-panel--summary">
                                        <div class="report-total-band report-total-band--compact">
                                            <div class="report-total-band__item">
                                                <span class="report-total-band__label">Total Pagado</span>
                                                <span class="report-total-band__value report-total-band__value--positive">
                                                    {{ (Number(pedido.valor_convenio_pagado || 0) + Number(pedido.pagosLiquidaciones || 0)) | filtrarDecimal2 }}
                                                </span>
                                            </div>
                                            <div class="report-total-band__item">
                                                <span class="report-total-band__label">Total x Pagar</span>
                                                <span class="report-total-band__value report-total-band__value--warning">
                                                    {{ (Number(pedido.convenio_x_pagar || 0) + Number(pedido.pagos_x_pagar || 0)) | filtrarDecimal2 }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="report-summary-head">
                                            <span class="report-section-eyebrow">Convenio & Resumen</span>
                                            <h3 class="report-section-title report-title-tight">Estado financiero</h3>
                                        </div>
                                        <div class="report-financial-columns">
                                            <div class="report-financial-column">
                                                <div class="report-summary-row report-summary-row--split">
                                                    <span class="report-mini-card__label">Global</span>
                                                    <span class="report-mini-card__value">{{ pedido.convenio_global }}</span>
                                                </div>
                                                <div class="report-summary-row report-summary-row--split">
                                                    <span class="report-mini-card__label">Conv. pag.</span>
                                                    <span class="report-mini-card__value">{{ pedido.valor_convenio_pagado | filtrarDecimal2 }}</span>
                                                </div>
                                                <div class="report-summary-row report-summary-row--split">
                                                    <span class="report-mini-card__label">Conv. x pagar</span>
                                                    <span class="report-mini-card__value">{{ pedido.convenio_x_pagar | filtrarDecimal2 }}</span>
                                                </div>
                                            </div>
                                            <div class="report-financial-column">
                                                <div class="report-summary-row report-summary-row--split">
                                                    <span class="report-mini-card__label">Pagos Pend.</span>
                                                    <span class="report-mini-card__value">{{ pedido.pagosPendientes | filtrarDecimal2 }}</span>
                                                </div>
                                                <div class="report-summary-row report-summary-row--split">
                                                    <span class="report-mini-card__label">Pagos pagados</span>
                                                    <span class="report-mini-card__value">{{ pedido.pagosLiquidaciones | filtrarDecimal2 }}</span>
                                                </div>
                                                <div class="report-summary-row report-summary-row--split">
                                                    <span class="report-mini-card__label">Pagos x pagar</span>
                                                    <span class="report-mini-card__value">{{ pedido.pagos_x_pagar | filtrarDecimal2 }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="report-meta-line report-meta-line--compact">
                                            <span>Tiempo: {{ pedido.convenio_anios }} años</span>
                                            <span>Inicio: {{ pedido.inicio_convenio }}</span>
                                            <span>Estado: {{ pedido.estado_convenio }}</span>
                                        </div>
                                    </div>
                                </td>
                                <td class="py-2 px-3 report-cell-white align-top">
                                    <div v-if="pedido.cantidad_pagos_total > 0" class="report-panel report-panel--payments">
                                        <div class="report-payment-head">
                                            <span class="report-section-eyebrow">Detalle de Pagos</span>
                                            <h3 class="report-section-title report-title-tight">Movimientos asociados</h3>
                                            <p class="report-payment-total">Total: {{ pedido.cantidad_pagos_total }} pagos</p>
                                        </div>
                                        <div class="report-payment-grid">
                                            <div class="report-payment-metric report-payment-metric--green">
                                                <span class="report-payment-metric__label">Cerr. pago</span>
                                                <span class="report-payment-metric__value">{{ pedido.pagos_cerrados_pago | filtrarDecimal2 }}</span>
                                            </div>
                                            <div class="report-payment-metric report-payment-metric--amber">
                                                <span class="report-payment-metric__label">Ab. pago</span>
                                                <span class="report-payment-metric__value">{{ pedido.pagos_abiertos_pago | filtrarDecimal2 }}</span>
                                            </div>
                                            <div class="report-payment-metric report-payment-metric--teal">
                                                <span class="report-payment-metric__label">Cerr. conv.</span>
                                                <span class="report-payment-metric__value">{{ pedido.pagos_cerrados_convenio | filtrarDecimal2 }}</span>
                                            </div>
                                            <div class="report-payment-metric report-payment-metric--orange">
                                                <span class="report-payment-metric__label">Ab. conv.</span>
                                                <span class="report-payment-metric__value">{{ pedido.pagos_abiertos_convenio | filtrarDecimal2 }}</span>
                                            </div>
                                        </div>

                                        <div class="rounded-xl overflow-hidden shadow-lg tabla-pagos-interna report-inner-table">
                                            <table class="min-w-full bg-white">
                                                <thead>
                                                    <tr class="report-inner-table-head">
                                                        <th class="py-2 px-2 text-left text-[9px] font-bold uppercase text-slate-700">ID</th>
                                                        <th class="py-2 px-2 text-left text-[9px] font-bold uppercase text-slate-700">Benef.</th>
                                                        <th class="py-2 px-2 text-left text-[9px] font-bold uppercase text-slate-700">Subtot.</th>
                                                        <th class="py-2 px-2 text-left text-[9px] font-bold uppercase text-slate-700">IVA</th>
                                                        <th class="py-2 px-2 text-left text-[9px] font-bold uppercase text-slate-700">Ret.</th>
                                                        <th class="py-2 px-2 text-left text-[9px] font-bold uppercase text-slate-700">Total</th>
                                                        <th class="py-2 px-2 text-left text-[9px] font-bold uppercase text-slate-700">Tipo</th>
                                                        <th class="py-2 px-2 text-left text-[9px] font-bold uppercase text-slate-700">Forma</th>
                                                        <th class="py-2 px-2 text-left text-[9px] font-bold uppercase text-slate-700">Estado</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="pago in pedido.todos_los_pagos" :key="pago.id_pedido_pago_detalle" class="report-inner-row">
                                                        <td class="py-2 px-2 text-[9px] font-semibold text-slate-700">{{ pago.id_pedido_pago_detalle }}</td>
                                                        <td class="py-2 px-2 text-[9px] text-slate-700">
                                                            <div v-if="pago.razon_social">
                                                                <p class="font-semibold">{{ pago.razon_social }}</p>
                                                                <p class="text-gray-500 text-[9px]">{{ pago.documento_dni || 'Sin documento' }}</p>
                                                            </div>
                                                            <div v-else>
                                                                <p>{{ pago.nombre_completo || 'N/A' }}</p>
                                                                <p class="text-gray-500 text-[9px]">{{ pago.documento_dni || 'Sin documento' }}</p>
                                                            </div>
                                                        </td>
                                                        <td class="py-2 px-2 text-[9px] text-slate-700">{{ pago.subtotal | filtrarDecimal2 }}</td>
                                                        <td class="py-2 px-2 text-[9px] text-slate-700">{{ pago.iva_valor | filtrarDecimal2 }}</td>
                                                        <td class="py-2 px-2 text-[9px] text-slate-700">{{ pago.retencion | filtrarDecimal2 }}</td>
                                                        <td class="py-2 px-2 text-[9px] font-bold text-slate-900">{{ pago.total_calculado | filtrarDecimal2 }}</td>
                                                        <td class="py-2 px-2 text-[9px]">
                                                            <span class="report-tag" :class="{
                                                                'report-tag--blue': pago.tipo_pago_id === 1,
                                                                'report-tag--purple': pago.tipo_pago_id === 2,
                                                                'report-tag--indigo': pago.tipo_pago_id === 7,
                                                                'report-tag--teal': pago.tipo_categoria === 'Convenio'
                                                            }">
                                                                {{ pago.tipo_pago_texto }}
                                                            </span>
                                                        </td>
                                                        <td class="py-2 px-2 text-[9px] text-slate-700">{{ pago.forma_pago_nombre || 'N/A' }}</td>
                                                        <td class="py-2 px-2 text-[9px]">
                                                            <span class="report-tag" :class="pago.estado === 1 ? 'report-tag--green' : 'report-tag--amber'">
                                                                {{ pago.estado_texto }}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div v-else class="report-panel report-panel--empty text-center py-8">
                                        <p class="text-gray-500 italic text-sm">Sin pagos registrados</p>
                                    </div>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </vx-card>
    </div>
</template>

<script>
import XLSX from 'xlsx'
import vSelect from 'vue-select'
import Generalmix from '@/mixins/Generalmix';
import Codigosmix from "@/mixins/Codigosmix";
export default {
    mixins: [Generalmix,Codigosmix],
    components: {
        vSelect,
    },
    data() {
        return {
            arrayPeriodos: [],
            periodoSelect: null,
            totalVenta: 0,
            totalVentaDescuento: 0,
            pedidos: [],
            searchQuery: '',
        }
    },

    computed: {
        pedidosFiltrados() {
            if (!this.searchQuery) {
                return this.pedidos;
            }
            const query = this.searchQuery.toLowerCase();
            return this.pedidos.filter(pedido => {
                return (
                    (pedido.nombreInstitucion && pedido.nombreInstitucion.toLowerCase().includes(query)) ||
                    (pedido.id_pedido && pedido.id_pedido.toString().includes(query)) ||
                    (pedido.pedido_institucion_id && pedido.pedido_institucion_id.toString().includes(query)) ||
                    (pedido.asesor_nombres && pedido.asesor_nombres.toLowerCase().includes(query)) ||
                    (pedido.asesor_apellidos && pedido.asesor_apellidos.toLowerCase().includes(query)) ||
                    (pedido.contrato_generado && pedido.contrato_generado.toLowerCase().includes(query)) ||
                    (pedido.tipo_venta_descr && pedido.tipo_venta_descr.toLowerCase().includes(query))
                );
            });
        },
        resumenReporte() {
            const pedidos = this.pedidosFiltrados || [];
            const money = new Intl.NumberFormat('es-EC', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            const asNumber = (value) => {
                const num = parseFloat(value);
                return Number.isFinite(num) ? num : 0;
            };

            const instituciones = new Set();
            let pagos = 0;
            let pagado = 0;
            let pendiente = 0;

            pedidos.forEach((pedido) => {
                if (pedido.nombreInstitucion) {
                    instituciones.add(pedido.nombreInstitucion);
                }
                pagos += asNumber(pedido.cantidad_pagos_total);
                pagado += asNumber(pedido.valor_convenio_pagado) + asNumber(pedido.pagosLiquidaciones);
                pendiente += asNumber(pedido.convenio_x_pagar) + asNumber(pedido.pagos_x_pagar);
            });

            return [
                {
                    label: 'Pedidos visibles',
                    value: pedidos.length,
                    helper: 'Resultados según el filtro actual',
                    className: 'report-stat-card--blue',
                },
                {
                    label: 'Instituciones',
                    value: instituciones.size,
                    helper: 'Unidades educativas incluidas',
                    className: 'report-stat-card--slate',
                },
                {
                    label: 'Pagos totales',
                    value: pagos,
                    helper: 'Suma de pagos cargados',
                    className: 'report-stat-card--emerald',
                },
                {
                    label: 'Total pagado',
                    value: money.format(pagado),
                    helper: 'Convenio + liquidaciones',
                    className: 'report-stat-card--indigo',
                },
                {
                    label: 'Total por pagar',
                    value: money.format(pendiente),
                    helper: 'Saldo restante estimado',
                    className: 'report-stat-card--amber',
                },
            ];
        }
    },

    mounted() {
        this.obtenerPeriodos()
    },

    methods: {
        obtenerPeriodos() {
            let me = this;
            this.$http.get(this.$server_url + 'periodo_nombre')
                .then(res => {
                    console.log('Periodos obtenidos:', res.data);
                    me.arrayPeriodos = res.data;
                })
        },
        f_get_pedidos_periodos() {
            console.log('IDs seleccionados:', this.periodoSelect);
            if (!this.periodoSelect || this.periodoSelect.length === 0) {
                console.warn('No hay periodos seleccionados');
                return;
            }

            this.$vs.loading();

            this.$http.post(this.$server_url + 'obtenerPedidosPorPeriodo', {
                periodos: this.periodoSelect // ya es array de IDs
            })
                .then(res => {
                    console.log('Pedidos:', res.data.data);
                    this.pedidos = res.data.data;
                })
                .catch(err => {
                    console.error('Error:', err);
                })
                .finally(() => {
                    this.$vs.loading.close();
                });
        },
        recargarPedidos() {
            if (!this.periodoSelect || this.periodoSelect.length === 0) {
                this.$vs.notify({
                    title: 'Advertencia',
                    text: 'Debe seleccionar al menos un periodo',
                    color: 'warning',
                    position: 'top-right'
                });
                return;
            }
            this.f_get_pedidos_periodos();
        },
        limpiarSeleccion() {
            this.periodoSelect = null;
            this.pedidos = [];
            this.$vs.notify({
                title: 'Limpiado',
                text: 'SelecciÃ³n de periodos limpiada',
                color: 'success',
                position: 'top-right'
            });
        },
        exportar() {
            let me = this;

            if (!me.pedidos || me.pedidos.length === 0) {
                me.$vs.notify({
                    title: 'Advertencia',
                    text: 'No hay datos para exportar',
                    color: 'warning',
                    position: 'top-right'
                });
                return;
            }

            const asNumber = (value) => {
                const num = parseFloat(value);
                return Number.isFinite(num) ? num : 0;
            };

            const formatNumber = (value) => {
                const num = asNumber(value);
                return Number(num.toFixed(2));
            };

            const detalleData = [];
            const resumenData = [];

            me.pedidos.forEach((pedido) => {
                const asesor = `${pedido.asesor_nombres || ''} ${pedido.asesor_apellidos || ''}`.trim();
                const pagos = Array.isArray(pedido.todos_los_pagos) ? pedido.todos_los_pagos : [];

                resumenData.push({
                    institucion: pedido.nombreInstitucion || '',
                    pedido: pedido.pedido_institucion_id || '',
                    convenio: pedido.pedidos_convenios_id || '',
                    asesor: asesor,
                    contrato: pedido.contrato_generado || '',
                    tipo_venta: pedido.tipo_venta_descr || '',
                    periodo: pedido.nombre_periodo || '',
                    convenio_global: asNumber(pedido.convenio_global),
                    convenio_pagado: formatNumber(pedido.valor_convenio_pagado),
                    convenio_x_pagar: formatNumber(pedido.convenio_x_pagar),
                    pagos_pendientes: formatNumber(pedido.pagosPendientes),
                    pagos_pagados: formatNumber(pedido.pagosLiquidaciones),
                    pagos_x_pagar: formatNumber(pedido.pagos_x_pagar),
                    tiempo_anios: pedido.convenio_anios || '',
                    inicio_convenio: pedido.inicio_convenio || '',
                    estado_convenio: pedido.estado_convenio || '',
                    cantidad_pagos: asNumber(pedido.cantidad_pagos_total),
                    total_pagado: formatNumber(asNumber(pedido.valor_convenio_pagado) + asNumber(pedido.pagosLiquidaciones)),
                    total_x_pagar: formatNumber(asNumber(pedido.convenio_x_pagar) + asNumber(pedido.pagos_x_pagar)),
                });

                pagos.forEach((pago) => {
                    detalleData.push({
                        contrato: pedido.contrato_generado || '',
                        institucion: pedido.nombreInstitucion || '',
                        asesor: asesor,
                        tipo_venta: pedido.tipo_venta_descr || '',
                        periodo: pedido.nombre_periodo || '',
                        id_pago: pago.id_pedido_pago_detalle || '',
                        beneficiario: pago.razon_social || pago.nombre_completo || 'N/A',
                        documento_dni: pago.documento_dni || '',
                        subtotal: formatNumber(pago.subtotal),
                        iva: formatNumber(pago.iva_valor),
                        retencion: formatNumber(pago.retencion),
                        total: formatNumber(pago.total_calculado),
                        tipo_pago: pago.tipo_pago_texto || '',
                        forma_pago: pago.forma_pago_nombre || 'N/A',
                        estado: pago.estado_texto || '',
                    });
                });
            });

            const headersDetalle = [
                'Contrato',
                'Institución',
                'Asesor',
                'Tipo Venta',
                'Periodo',
                'ID Pago',
                'Beneficiario',
                'Documento',
                'Subtotal',
                'IVA',
                'Retención',
                'Total',
                'Tipo Pago',
                'Forma Pago',
                'Estado',
            ];

            const headersResumen = [
                'Institución',
                'Pedido',
                'Convenio',
                'Asesor',
                'Contrato',
                'Tipo Venta',
                'Periodo',
                'Convenio Global',
                'Convenio Pagado',
                'Convenio x Pagar',
                'Pagos Pendientes',
                'Pagos Pagados',
                'Pagos x Pagar',
                'Tiempo Años',
                'Inicio Convenio',
                'Estado Convenio',
                'Cantidad Pagos',
                'Total Pagado',
                'Total x Pagar',
            ];

            const buildSheet = (rows, headerLabels, keys) => {
                const matrix = [headerLabels];
                rows.forEach((row) => {
                    matrix.push(keys.map((key) => row[key] !== undefined && row[key] !== null ? row[key] : ''));
                });
                return XLSX.utils.aoa_to_sheet(matrix);
            };

            const wsDetalle = buildSheet(detalleData, headersDetalle, [
                'contrato',
                'institucion',
                'asesor',
                'tipo_venta',
                'periodo',
                'id_pago',
                'beneficiario',
                'documento_dni',
                'subtotal',
                'iva',
                'retencion',
                'total',
                'tipo_pago',
                'forma_pago',
                'estado',
            ]);

            const wsResumen = buildSheet(resumenData, headersResumen, [
                'institucion',
                'pedido',
                'convenio',
                'asesor',
                'contrato',
                'tipo_venta',
                'periodo',
                'convenio_global',
                'convenio_pagado',
                'convenio_x_pagar',
                'pagos_pendientes',
                'pagos_pagados',
                'pagos_x_pagar',
                'tiempo_anios',
                'inicio_convenio',
                'estado_convenio',
                'cantidad_pagos',
                'total_pagado',
                'total_x_pagar',
            ]);
            wsDetalle['!cols'] = [
                { wch: 16 },
                { wch: 34 },
                { wch: 24 },
                { wch: 16 },
                { wch: 16 },
                { wch: 12 },
                { wch: 34 },
                { wch: 16 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 16 },
                { wch: 16 },
                { wch: 12 },
            ];
            wsResumen['!cols'] = [
                { wch: 36 },
                { wch: 12 },
                { wch: 12 },
                { wch: 28 },
                { wch: 18 },
                { wch: 16 },
                { wch: 16 },
                { wch: 14 },
                { wch: 14 },
                { wch: 14 },
                { wch: 14 },
                { wch: 14 },
                { wch: 14 },
                { wch: 12 },
                { wch: 16 },
                { wch: 16 },
                { wch: 14 },
                { wch: 14 },
                { wch: 14 },
            ];

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, wsDetalle, 'Detalle Pagos');
            XLSX.utils.book_append_sheet(wb, wsResumen, 'Resumen Institucion');
            XLSX.writeFile(wb, 'reporte_detalle_pagos_por_periodo.xlsx');
        }
    }
}
</script>

<style scoped>
.report-card-shell {
    border-radius: 18px;
    overflow: hidden;
}

.report-hero {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 18px;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid #dbe4f0;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.report-hero__copy {
    min-width: 0;
}

.report-hero__eyebrow {
    display: inline-flex;
    align-items: center;
    margin-bottom: 6px;
    padding: 3px 8px;
    border-radius: 9999px;
    background: #eff6ff;
    color: #334155;
    font-size: 9px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    font-weight: 700;
}

.report-hero__title {
    color: #0f172a;
    font-size: 16px;
    line-height: 1.05;
}

.report-hero__subtitle {
    color: #64748b;
    line-height: 1.25;
}

.report-action-btn {
    border-radius: 9999px;
    min-width: 92px;
    height: 34px;
    padding-left: 14px;
    padding-right: 14px;
    font-size: 11px;
}

.report-btn-primary {
    background: linear-gradient(135deg, #1d4ed8, #2563eb) !important;
    border: none !important;
}

.report-btn-secondary {
    background: linear-gradient(135deg, #475569, #334155) !important;
    border: none !important;
}

.report-btn-danger {
    background: linear-gradient(135deg, #c2410c, #dc2626) !important;
    border: none !important;
}

.report-stats-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 6px;
    margin-bottom: 8px;
}

.report-stat-card {
    border-radius: 12px;
    border: 1px solid #dbe4f0;
    background: #ffffff;
    box-shadow: 0 4px 10px rgba(15, 23, 42, 0.03);
    padding: 8px 10px;
}

.report-stat-label {
    display: block;
    font-size: 7px;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #64748b;
}

.report-stat-value {
    display: block;
    margin-top: 2px;
    font-size: 13px;
    line-height: 1.1;
    font-weight: 800;
    color: #0f172a;
}

.report-stat-helper {
    display: block;
    margin-top: 2px;
    font-size: 7px;
    color: #64748b;
}

.report-stat-card--blue {
    border-left: 4px solid #60a5fa;
}

.report-stat-card--slate {
    border-left: 4px solid #94a3b8;
}

.report-stat-card--emerald {
    border-left: 4px solid #34d399;
}

.report-stat-card--indigo {
    border-left: 4px solid #818cf8;
}

.report-stat-card--amber {
    border-left: 4px solid #f59e0b;
}

.report-toolbar {
    display: grid;
    grid-template-columns: 1.4fr 1fr;
    gap: 10px;
    align-items: start;
}

.report-filter-card,
.report-search-card,
.report-table-shell {
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.04);
}

.report-filter-card {
    padding: 12px;
    min-height: 100%;
}

.report-filter-card__label {
    margin-bottom: 8px;
}

.report-filter-card__title {
    display: block;
    font-size: 10px;
    font-weight: 800;
    color: #1e293b;
}

.report-filter-card__subtitle {
    display: block;
    margin-top: 1px;
    font-size: 8px;
    color: #64748b;
}

.report-select {
    border-radius: 14px;
}

.report-search-card {
    padding: 10px;
    min-height: 100%;
    display: flex;
    align-items: center;
}

.report-search-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 10px;
    background: linear-gradient(135deg, #eff6ff, #f8fafc);
    font-size: 9px;
    font-weight: 700;
    color: #334155;
    letter-spacing: 0.02em;
    flex: 0 0 auto;
}

.report-search-input {
    background: #ffffff;
    color: #0f172a;
    min-height: 34px;
    font-size: 11px;
}

.report-search-count {
    white-space: nowrap;
    font-size: 8px;
    font-weight: 700;
    color: #334155;
    padding: 6px 8px;
    border-radius: 9999px;
    background: #f8fafc;
    border: 1px solid #dbe4f0;
}

.report-table {
    box-shadow: 0 12px 26px rgba(15, 23, 42, 0.05);
}

.report-table-fixed {
    table-layout: fixed;
}

.report-col-institution {
    width: 26%;
}

.report-col-summary {
    width: 24%;
}

.report-col-payments {
    width: 50%;
}

.report-table-head {
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%);
    color: #1e293b;
}

.report-table-head th {
    color: #334155 !important;
    border-bottom: 1px solid #e2e8f0;
}

.report-th-index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 20px;
    padding: 0 6px;
    border-radius: 9999px;
    background: #ffffff;
    border: 1px solid #cbd5e1;
    color: #475569;
    font-size: 8px;
    font-weight: 800;
    letter-spacing: 0.08em;
}

.report-table tbody tr {
    border-bottom: 1px solid #e8edf3 !important;
}

.report-row-hover:hover {
    background: #f8fafc;
}

.report-cell-soft {
    background: linear-gradient(180deg, #ffffff 0%, #fbfcfd 100%);
}

.report-cell-accent {
    background: linear-gradient(180deg, #fbfcfd 0%, #f5f7fa 100%);
}

.report-cell-white {
    background: #ffffff;
}

.report-panel {
    display: flex;
    flex-direction: column;
    gap: 6px;
    height: 100%;
}

.report-panel--institution,
.report-panel--summary,
.report-panel--payments,
.report-panel--empty {
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    background: #ffffff;
    padding: 8px 9px;
    box-shadow: 0 4px 10px rgba(15, 23, 42, 0.03);
}

.report-section-header {
    padding-bottom: 8px;
    border-bottom: 1px solid #e8edf3;
}

.report-section-header--compact {
    padding-bottom: 7px;
}

.report-section-eyebrow {
    display: inline-block;
    font-size: 7px;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #64748b;
    margin-bottom: 2px;
}

.report-section-title {
    font-size: 10px;
    line-height: 1.05;
    font-weight: 800;
    color: #0f172a;
}

.report-title-tight {
    margin-top: 0;
}

.report-section-subtitle {
    margin-top: 1px;
    font-size: 7px;
    color: #64748b;
}

.report-summary-head {
    display: flex;
    flex-direction: column;
    gap: 1px;
}

.report-summary-list {
    display: grid;
    gap: 4px;
}

.report-summary-list--institution {
    grid-template-columns: 1fr;
}

.report-summary-row {
    display: flex;
    flex-direction: column;
    gap: 1px;
    padding: 5px 6px;
    border-radius: 10px;
    background: #fbfdff;
    border: 1px solid #e5e7eb;
    min-width: 0;
}

.report-summary-row--split {
    justify-content: space-between;
}

.report-financial-columns {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px;
}

.report-financial-column {
    display: grid;
    gap: 4px;
    min-width: 0;
}

.report-mini-card {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 8px;
    border-radius: 14px;
    background: #fbfdff;
    border: 1px solid #e5e7eb;
}

.report-inline-meta {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
    padding: 8px;
    border-radius: 12px;
    background: #fbfdff;
    border: 1px solid #e5e7eb;
}

.report-mini-card__row {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.report-mini-card__label {
    font-size: 7px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #64748b;
    line-height: 1.05;
}

.report-mini-card__value {
    font-size: 8px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.1;
    word-break: break-word;
}

.report-mini-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.report-badge,
.report-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 20px;
    padding: 2px 6px;
    border-radius: 9999px;
    font-size: 8px;
    font-weight: 700;
    border: 1px solid transparent;
}

.report-badge--blue,
.report-tag--blue {
    background: #f8fafc;
    color: #334155;
    border-color: #e5e7eb;
}

.report-badge--slate {
    background: #f8fafc;
    color: #475569;
    border-color: #e2e8f0;
}

.report-tag--purple {
    background: #f5f3ff;
    color: #7c3aed;
    border-color: #e9d5ff;
}

.report-tag--indigo {
    background: #eef2ff;
    color: #4f46e5;
    border-color: #c7d2fe;
}

.report-tag--teal {
    background: #f0fdfa;
    color: #0f766e;
    border-color: #ccfbf1;
}

.report-tag--green {
    background: #f0fdf4;
    color: #15803d;
    border-color: #bbf7d0;
}

.report-tag--amber {
    background: #fffbeb;
    color: #b45309;
    border-color: #fde68a;
}

.report-kpi-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px;
}

.report-kpi-box {
    padding: 7px 8px;
    border-radius: 10px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.report-kpi-label {
    display: block;
    font-size: 8px;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #64748b;
}

.report-kpi-value {
    display: block;
    margin-top: 0;
    font-size: 11px;
    font-weight: 800;
    color: #0f172a;
}

.report-info-strip {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
    padding: 10px 12px;
    border-radius: 14px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
}

.report-info-strip--compact {
    margin-top: 2px;
}

.report-meta-line {
    display: flex;
    flex-wrap: wrap;
    gap: 3px 8px;
    padding: 4px 6px;
    border-radius: 10px;
    background: #fbfdff;
    border: 1px solid #e5e7eb;
    font-size: 7px;
    color: #475569;
}

.report-info-label {
    display: block;
    font-size: 8px;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #64748b;
}

.report-info-value {
    display: block;
    margin-top: 2px;
    font-size: 10px;
    font-weight: 700;
    color: #0f172a;
}

.report-total-band {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
}

.report-total-band--compact {
    margin-bottom: 4px;
}

.report-total-band__item {
    padding: 7px 8px;
    border-radius: 10px;
    background: #f8fdf8;
    border: 1px solid #d1fae5;
}

.report-total-band__label {
    display: block;
    font-size: 7px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #64748b;
}

.report-total-band__value {
    display: block;
    margin-top: 2px;
    font-size: 10px;
    font-weight: 800;
    line-height: 1;
}

.report-total-band__value--positive {
    color: #15803d;
}

.report-total-band__value--warning {
    color: #059669;
}

.report-payment-head {
    padding: 0;
}

.report-payment-total {
    font-size: 9px;
    font-weight: 800;
    color: #334155;
}

.report-payment-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px;
}

.report-payment-metric {
    padding: 6px 7px;
    border-radius: 10px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
}

.report-payment-metric__label {
    display: block;
    font-size: 7px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #64748b;
}

.report-payment-metric__value {
    display: block;
    margin-top: 2px;
    font-size: 9px;
    line-height: 1;
    font-weight: 800;
    color: #0f172a;
}

.report-payment-metric--green {
    border-left: 3px solid #94a3b8;
}

.report-payment-metric--amber {
    border-left: 3px solid #94a3b8;
}

.report-payment-metric--teal {
    border-left: 3px solid #94a3b8;
}

.report-payment-metric--orange {
    border-left: 3px solid #94a3b8;
}

.report-inner-table {
    border-radius: 14px;
    border: 1px solid #e2e8f0;
}

.report-inner-table table {
    table-layout: fixed;
    font-size: 8px;
}

.report-inner-table-head {
    background: #f8fafc;
}

.report-inner-table-head th {
    border-bottom: 1px solid #e2e8f0;
    color: #475569 !important;
    padding-top: 6px !important;
    padding-bottom: 6px !important;
}

.report-inner-row {
    border-bottom: 1px solid #eef2f7;
}

.report-inner-row:hover {
    background: #fbfdff;
}

.report-inner-row td {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
}

.tabla-pagos-interna {
    border: 1px solid #e2e8f0 !important;
    border-radius: 14px;
}

.kpi-card {
    border-radius: 14px;
    padding: 14px 16px;
    border-left: 4px solid transparent;
    background: #fff;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);
}

.report-empty-state {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 14px 18px;
    border-radius: 18px;
    background: #f8fafc;
    border: 1px dashed #cbd5e1;
    color: #475569;
}

@media (max-width: 1024px) {
    .report-stats-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .report-toolbar {
        grid-template-columns: 1fr;
    }

    .report-hero {
        flex-direction: column;
    }
}

@media (max-width: 640px) {
    .report-card-shell .container {
        padding-left: 10px !important;
        padding-right: 10px !important;
    }

    .report-hero {
        padding: 12px;
        gap: 10px;
    }

    .report-hero__title {
        font-size: 14px;
    }

    .report-stats-grid {
        gap: 5px;
        margin-bottom: 6px;
    }

    .report-stats-grid {
        grid-template-columns: 1fr;
    }

    .report-toolbar {
        gap: 8px;
    }

    .report-filter-card,
    .report-search-card,
    .report-table-shell {
        border-radius: 14px;
    }

    .report-filter-card {
        padding: 10px;
    }

    .report-search-card {
        padding: 8px;
    }

    .report-action-btn {
        width: 100%;
    }

    .report-table-shell {
        overflow-x: visible;
    }

    .report-table-fixed {
        table-layout: auto;
    }

    .report-table,
    .report-table thead,
    .report-table tbody,
    .report-table tr,
    .report-table th,
    .report-table td {
        display: block;
        width: 100%;
    }

    .report-table-head {
        display: none;
    }

    .report-table tbody tr {
        margin-bottom: 10px;
        border: 1px solid #e2e8f0;
        border-radius: 14px;
        overflow: hidden;
        background: #ffffff;
        box-shadow: 0 8px 18px rgba(15, 23, 42, 0.04);
    }

    .report-table tbody td {
        padding: 8px !important;
    }

    .report-panel--institution,
    .report-panel--summary,
    .report-panel--payments,
    .report-panel--empty {
        padding: 8px;
    }

    .report-financial-columns,
    .report-payment-grid {
        grid-template-columns: 1fr;
    }

    .report-inner-table {
        overflow-x: auto;
    }

    .report-inner-table table {
        min-width: 720px;
    }

    .report-payment-total {
        font-size: 8px;
    }

    .report-mini-badges {
        gap: 3px;
    }
}

.report-card-shell :deep(.vs-inputx),
.report-card-shell :deep(input),
.report-card-shell :deep(select) {
    border-radius: 12px !important;
}

.report-card-shell :deep(.vs-button) {
    border-radius: 9999px !important;
    text-transform: none;
    letter-spacing: 0;
}
</style>
